import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/tripadvisor': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M166.4 280.5c0 13.2-10.7 24-24 24-13.2 0-24-10.7-24-24 0-13.2 10.7-24 24-24 13.2 0 24 10.7 24 24zM431.4 256.6c13.2 0 24 10.7 24 24 0 13.2-10.7 24-24 24-13.2 0-24-10.7-24-24 0-13.2 10.7-24 24-24zM520.8 396.1c-62.7 49.1-153.3 38.1-202.4-24.6l-31 46.3-30.7-45.9c-48.3 60.4-135.6 71.9-197.9 26.1-64.1-47.2-77.8-137.3-30.6-201.4-5.1-17.1-17.7-42.7-28.2-57.1l90.3 0c48-29.9 132.9-54.1 189.4-54.1 2.1 0 5.6 0 7.7 0.1 1.7 0 4.5-0.1 6.2-0.1 55.6 0 138.9 23.9 185.9 53.4l96.2 0.1c-10.6 14.5-23.3 40.4-28.4 57.6 46.8 62.7 35 151.4-26.6 199.6zM259.4 281.8c0-63.6-51.5-115.1-115.1-115.1-63.6 0-115.1 51.5-115.1 115.1 0 63.6 51.5 115.1 115.1 115.1 63.5-0.1 115-51.5 115.1-115.1v0zM288 271.3c5.4-73.4 65.5-130.9 139.1-133-35.6-15.4-95.9-27.9-134.6-27.9-1.4 0-3.7 0-5.1 0-1 0-2.5 0-3.5 0-39.2 0-100.5 12.2-136.7 27.3 74.3 1.6 135.3 59.4 140.8 133.6zM539.7 242.5c-22-59.6-88.2-90.1-147.8-68.2-59.6 22-90.1 88.2-68.2 147.8v0c22 59.6 88.2 90.1 147.8 68.1 59.6-22 90.1-88.2 68.1-147.8zM213.6 280.5v0.1c-0.1 39.3-32 71.2-71.3 71.1-39.3-0.1-71.2-32-71.1-71.3s32-71.2 71.3-71.1c39.3 0.1 71 31.9 71.1 71.2zM189.1 280.5v-0.1c-0.1-25.8-21-46.6-46.8-46.6s-46.6 21-46.6 46.8c0.1 25.8 21 46.6 46.8 46.6 25.7-0.1 46.5-21 46.6-46.7zM502.5 280.5c0 39.3-31.9 71.2-71.2 71.2-39.3 0-71.2-31.9-71.2-71.2 0-39.3 31.9-71.2 71.2-71.2 39.3 0.1 71.1 31.9 71.2 71.2zM478 280.5c0-25.8-20.9-46.7-46.7-46.7s-46.7 20.9-46.7 46.7 20.9 46.7 46.7 46.7c25.8 0 46.6-20.9 46.7-46.7v0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/tripadvisor.js
// module id = 1059
// module chunks = 0